import { render, staticRenderFns } from "./Collecte.vue?vue&type=template&id=5b2a0130&scoped=true"
import script from "./Collecte.vue?vue&type=script&lang=js"
export * from "./Collecte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2a0130",
  null
  
)

export default component.exports